import React, { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  CircularProgress,
  Divider,
  InputBase,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Typography,
  useTheme,
} from "@mui/material";
import MenuBarIcon from "../../assets/icons/MenuBar.svg";
import Bell from "../../assets/icons/Bell.svg";
import QuestionMarkCircle from "../../assets/icons/QuestionMarkCircle.svg";
// import Avatar from "../../assets/icons/Avatar.svg";
import logoIcon from "../../assets/icons/logo.svg";
import HeaderBackground from "../../assets/img/HeaderBackground.jpg";
import { CenterFocusStrong, Search as SearchIcon } from "@mui/icons-material";
import { TopBarSearchStyledBox, TopBarStyeldBox } from "../../styled";
import { VisionStudioSpinner, VisionStudioSvg } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";
import Logout from "../../assets/icons/logout.png";
import Avatar from "../../assets/icons/Avatar.svg";
import {
  LAPTOP_SIZE_SCREEN,
  DESKTOP_4K_SIZE_SCREEN,
  SMALL_MOBILE_SIZE_SCREEN,
  MOBILE_SIZE_SCREEN,
} from "../../constants";
import { useDeviceSize } from "../../hooks";
import { DeviceSizeProps } from "../../types/interface";
import LogoSVG from "../../assets/icons/logosvg.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UseDispatch } from "react-redux";
import { fetchProjectById } from "../../store/slice/projectHandler";
import { ReactSVG } from "react-svg";
import { getSearchData } from "../../store/slice/ProjectLabelSlice";
import { fetchTasks } from "../../store/slice/ProjectTasksSlice";
import localStorageService from "../../Service/LocalstorageService";
/**
 *
 * Componet to display the TopBar UI.
 *
 */

export interface Project {
  id: string;
  labels: number;
  images: number;
  annotations: number;
  models: number;
  imageUrl: string;
  thubmImageUrl: string;
  name: string;
  description: string;
  taskTypeId: string;
  domainTypeId: string;
  createdDate: string; // Consider changing this to Date if you parse it
  customerId: string;
  liked: boolean;
  annotatedImageCount?: number;
}
export const Topbar: React.FC = () => {
  const theme = useTheme();
  const dispatch: AppDispatch = useDispatch();
  const { id } = useParams();
  const location: any = useLocation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openSearch, setOpenSearch] = useState<boolean>(false);
  const [paths, setPaths] = useState<boolean>(false);
  const [project, setProject] = useState<Project>({
    id: "",
    labels: 0,
    images: 0,
    annotations: 0,
    models: 0,
    imageUrl: "",
    thubmImageUrl: "",
    name: "",
    description: "",
    taskTypeId: "",
    domainTypeId: "",
    createdDate: "",
    customerId: "",
    liked: false,
  });
  interface SearchAnything {
    id: string;
    name: string;
    type: string;
    colour?: string;
  }

  const { tasks } = useSelector((state: RootState) => state.Tasks);

  const [setSearchData] = useState<SearchAnything[] | undefined>(undefined);
  const open = Boolean(anchorEl);
  const [searchQuery, setSearchQuery] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
  const navigate = useNavigate();
  const [initial, setInitial] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);

  // Debounce function
  const debounce = (func: (...args: any[]) => void, delay: number) => {
    return (...args: any[]) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const logout = () => {
    document.cookie =
      ".AspNetCore.Antiforgery.qKMI6Lrj50Q=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=.unifynow.ai;";
    document.cookie =
      ".AspNet.SharedCookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=.unifynow.ai;";
    document.cookie =
      "_ga=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=.unifynow.ai;";
    document.cookie =
      "_ga_2Q9GWJ88WT=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=.unifynow.ai;";

    localStorageService.clearAuthTokens();
    window.location.replace("/Login");
  };

  useEffect(() => {
    if (paths) {
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  }, [paths]);

  const plan = localStorage.getItem("plan");

  // API call function
  const fetchData = async (query: string) => {
    if (query.trim() === "") return;
    dispatch(getSearchData(query))
      .unwrap()
      .then(() => setInitial(false));
    setOpenSearch(true);
  };

  // Debounced version of fetchData
  const debouncedFetchData = debounce(fetchData, 500);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInitial(true);
    const value = event.target.value;
    const check = value
      .trimStart()
      .slice(0, 50)
      .replace(/\s{2,}/g, " ");
    setSearchQuery(check);
    debouncedFetchData(check);
  };

  useEffect(() => {
    if (searchQuery.length == 0) {
      setOpenSearch(false);
    }
  }, [searchQuery]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRenew = () => {
    const plan = localStorage.getItem("plan");
    if (plan === "Institution") {
      navigate("/myplan");
    } else {
      const customerId = localStorage.getItem("customerId");
      // Open the "Plans" page in a new tab
      window.open(
        `/upgrade/plan`,
        "_blank"
      );
    }
  };

  const handleCloseSearch = () => {
    setOpenSearch(false);
  };
  const { topBarTitle } = useSelector((state: RootState) => state.UIReducer);
  const { searchData } = useSelector((state: RootState) => state.projectLabel);
  const deviceSize = useDeviceSize();
  const [topTitles, setTopTitles] = useState("");

  const loadTopData = () => {
    setTopTitles("");
    if (location.pathname.includes("project/")) {
      setLoader(true);
      setPaths(true);
      if (id) {
        dispatch(fetchProjectById(id))
          .then((response) => {
            setProject(response?.payload);
            setLoader(false);

            // console.log("Fetch Project Success:", response?.payload); // Log response here on success
          })
          .catch((error) => {
            setLoader(false);
            console.error("Fetch Project Failed:", error); // Log error on failure
          });
      }
    } else {
      setPaths(false);
    }
  };

  useEffect(() => {
    loadTopData();
  }, [location]);

  useEffect(() => {
    setTopTitles(topBarTitle);
  }, [topBarTitle]);

  useEffect(() => {
    if (tasks.length === 0) {
      dispatch(fetchTasks());
    }
  }, [tasks]);

  // const handleBlur = (e: any) => {
  //   e.target.focus();
  // };

  const findNameById = (id: string) => {
    const item = tasks.find((entry) => entry.id === id);
    return item ? item.name : undefined;
  };

  const taskId: string | undefined = project?.taskTypeId;
  const taskName = taskId ? findNameById(taskId) : "Invalid ID";
  localStorage.setItem("projectTitle", project?.name);

  const navigateToProject = (item: SearchAnything) => {
    navigate(`/project/${item.id}`);
    setSearchQuery("");
    inputRef?.current?.blur();
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: 1201,
        backgroundColor: theme.palette.common.white,
        backgroundImage: `url(${HeaderBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      style={{
        zIndex: "999",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "0 1rem",
          height: "3rem",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start", // Align items to the start
            marginLeft: "0.75rem",
            width: "100%", // Ensure it takes the full width
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <div className="icon-wrapper">
              <ReactSVG src={MenuBarIcon} />
            </div>
            {/* <VisionStudioSvg icon={MenuBarIcon} /> */}
            <Box
              sx={{
                marginLeft:
                  deviceSize === SMALL_MOBILE_SIZE_SCREEN ||
                  deviceSize === MOBILE_SIZE_SCREEN
                    ? "0.5rem"
                    : "1.5rem",
              }}
            >
              <img src={LogoSVG} alt="logo" style={{ height: "20px" }} />
            </Box>
            <Typography
              sx={{
                color: "#49454f",
                fontSize: "18px",
                fontWeight: "600",
                textAlign: "center", // Center text within Typography
              }}
              variant="h1"
            >
              Vision Studio
            </Typography>
          </Box>

          {/* Centering the span element */}
          <Box
            sx={{
              flexGrow: 1, // Allow this Box to take up remaining space
              display:
                deviceSize === DESKTOP_4K_SIZE_SCREEN ||
                deviceSize === LAPTOP_SIZE_SCREEN
                  ? "flex"
                  : "none",
              justifyContent: "center",
              // Center content within this Box
              color: "#666",
            }}
          >
            <Typography
              sx={{
                color: "#49454f",
                fontSize: "18px",
                fontWeight: "600",
                textAlign: "center", // Center text within Typography
              }}
              variant="h1"
            >
              {loader ? (
                ""
              ) : paths && project?.name ? (
                <>
                  {project?.name}
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    ({taskName})
                  </span>
                </>
              ) : (
                ""
              )}
            </Typography>
          </Box>
        </Box>

        {topTitles && (
          <Box
            sx={{
              color: "#000000",
              width:
                deviceSize === SMALL_MOBILE_SIZE_SCREEN ||
                deviceSize === MOBILE_SIZE_SCREEN
                  ? "50%"
                  : "auto",
            }}
          >
            <Typography
              fontSize={
                deviceSize === SMALL_MOBILE_SIZE_SCREEN ||
                deviceSize === MOBILE_SIZE_SCREEN
                  ? "0.8rem"
                  : "1rem"
              }
              fontWeight="300"
              textAlign="center"
            >
              {topTitles}
            </Typography>
          </Box>
        )}
        <Box
          display="flex"
          sx={{
            flex: "0 0 33%",
            justifyContent: "end",
            alignItems: "center",
            gap: "2px",
          }}
        >
          <Box sx={{ position: "relative", flex: "1" }}>
            <TopBarSearchStyledBox
              deviceSize={deviceSize as DeviceSizeProps}
              display={
                deviceSize === DESKTOP_4K_SIZE_SCREEN ||
                deviceSize === LAPTOP_SIZE_SCREEN
                  ? "flex"
                  : "none"
              }
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "4px",
                  width: "100%",
                }}
              >
                <InputBase
                  id="searchTopBar"
                  placeholder="Search Here"
                  sx={{
                    marginLeft: "0.5rem",
                    flex: 1,
                    ".MuiInputBase-input": {
                      color: "#00000166",
                    },
                  }}
                  inputRef={inputRef}
                  value={searchQuery}
                  onChange={handleSearchChange}
                  onBlur={() => {
                    setTimeout(() => {
                      setSearchQuery("");
                    }, 300);
                  }}
                />
                {/* <SearchIcon
                  sx={{
                    ml: "0.5rem",
                    pr: "1rem",
                    color: "#000000",
                    cursor: "pointer",
                  }}
                /> */}
              </Box>
            </TopBarSearchStyledBox>

            {searchQuery.length > 1 ? (
              <Box>
                <Box
                  sx={{
                    top: "38px",
                    background: "white",
                    position: "absolute",
                    left: "1rem",
                    width: "90%",
                    boxShadow: "0 10px 10px #8080803b",
                    borderBottomLeftRadius: "6px",
                    borderBottomRightRadius: "6px",
                    // backgroundColor: "#000"
                  }}
                >
                  <Typography
                    sx={{ padding: "10px", display: "flex", color: "black" }}
                  >
                    Suggested Results for
                    <span style={{ display: "flex" }}>
                      <span
                        style={{
                          maxWidth: "85px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          display: "block",
                        }}
                      >
                        "{searchQuery}"
                      </span>
                    </span>
                  </Typography>

                  <List
                    style={{
                      position: "relative",
                      cursor: "pointer",
                      maxHeight: "calc(100vh - 170px)",
                      overflow: "scroll",
                    }}
                  >
                    {initial ? (
                      <ListItem
                        sx={{
                          padding: "20px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <CircularProgress />
                      </ListItem>
                    ) : searchData && searchData.length === 0 ? (
                      <ListItem sx={{ padding: "20px" }}>
                        <ListItemText
                          sx={{
                            color: "#595959",
                            fontSize: "19px",
                            fontWeight: "400",
                            textAlign: "center",
                          }}
                        >
                          Projects and Models not found for this search.
                        </ListItemText>
                      </ListItem>
                    ) : (
                      <>
                        {searchData?.some(
                          (item) => item.type === "Project"
                        ) && (
                          <Typography
                            sx={{
                              padding: "10px",
                              fontWeight: "bold",
                              color: "black",
                              margin: "0",
                              fontSize: "13px",
                              // textAlign: "center",
                              cursor: "default",
                            }}
                          >
                            Projects
                          </Typography>
                        )}

                        {searchData
                          ?.filter(
                            (item: SearchAnything) => item.type === "Project"
                          )
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((item: SearchAnything) => (
                            <ListItem
                              key={item.id}
                              sx={{ "&:hover": { background: "#73A9F838" } }}
                              onClick={() => navigateToProject(item)}
                            >
                              <ListItemIcon>
                                <span
                                  style={{
                                    background: item.colour,
                                    border: "1px solid white",
                                    borderRadius: "50%",
                                    height: "32px",
                                    width: "32px",
                                    textAlign: "center",
                                    marginRight: "10px",
                                    alignContent: "center",
                                  }}
                                >
                                  {item.name[0]}
                                </span>
                              </ListItemIcon>
                              <Typography
                                sx={{
                                  color: "#595959",
                                  fontSize: "16px",
                                  fontWeight: "400",
                                  maxWidth: "250px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <abbr
                                  title={item.name}
                                  style={{ textDecoration: "none" }}
                                >
                                  {item.name}
                                </abbr>
                              </Typography>
                            </ListItem>
                          ))}

                        {searchData?.some((item) => item.type === "Model") && (
                          <Typography
                            sx={{
                              padding: "10px",
                              fontWeight: "bold",
                              color: "black",
                              margin: "0",
                              fontSize: "13px",
                              // textAlign: "center",
                              cursor: "default",
                            }}
                          >
                            Models
                          </Typography>
                        )}
                        {searchData
                          ?.filter(
                            (item: SearchAnything) => item.type === "Model"
                          )
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((item: SearchAnything) => (
                            <ListItem
                              key={item.id}
                              sx={{ "&:hover": { background: "#73A9F838" } }}
                              onClick={() => {
                                navigate(`/models`);
                                setSearchQuery("");
                                inputRef?.current?.blur();
                              }}
                            >
                              <ListItemIcon>
                                <span
                                  style={{
                                    background: item.colour,
                                    border: "1px solid white",
                                    borderRadius: "50%",
                                    height: "32px",
                                    width: "32px",
                                    textAlign: "center",
                                    marginRight: "15px",
                                    alignContent: "center",
                                  }}
                                >
                                  {item.name[0]}
                                </span>
                              </ListItemIcon>
                              <Typography
                                sx={{
                                  color: "#595959",
                                  fontSize: "16px",
                                  fontWeight: "400",
                                  maxWidth: "250px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <abbr
                                  title={item.name}
                                  style={{ textDecoration: "none" }}
                                >
                                  {item.name}
                                </abbr>
                              </Typography>
                            </ListItem>
                          ))}
                      </>
                    )}
                  </List>
                </Box>
              </Box>
            ) : (
              <></>
            )}
          </Box>

          <TopBarStyeldBox deviceSize={deviceSize as DeviceSizeProps}>
            <Button
              variant="contained"
              sx={{ width: "130px", background: "#f77181", fontSize: "12px" }}
              onClick={handleRenew}
            >
              {plan === "Institution" ? "My Plan" : "Upgrade Now"}
            </Button>
          </TopBarStyeldBox>
          {/* <TopBarStyeldBox deviceSize={deviceSize as DeviceSizeProps}>
            <img
              src={Bell}
              alt="Bell"
              style={{ height: "20px", width: "20px", objectFit: "contain" }}
            />
          </TopBarStyeldBox> */}
          {/* <TopBarStyeldBox
            sx={{ marginLeft: "0.3rem" }}
            deviceSize={deviceSize as DeviceSizeProps}
          >
            <img
              src={QuestionMarkCircle}
              alt="logo"
              style={{ height: "20px", width: "20px", objectFit: "contain" }}
            />
          </TopBarStyeldBox> */}
          <Tooltip title="">
            <IconButton
              onClick={handleClick}
              size="small"
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Box
                sx={{
                  border: "2px solid #1d97f3",
                  borderRadius: "50%",
                  height: "30px",
                  width: "30px",
                  background: "#1d97f3",
                  alignContent: "center",
                  color: "white",
                  "&:hover": {
                    background: "white",
                    color: "#1d97f3",
                  },
                }}
              >
                {"userName" in localStorage &&
                localStorage.getItem("userName") !== null
                  ? (() => {
                      const userName = localStorage.getItem("userName")!;
                      return (
                        <p
                          style={{
                            margin: 0,
                            textTransform: "uppercase",
                            // color: "white",
                          }}
                        >
                          <abbr
                            title={userName}
                            style={{ textDecoration: "none" }}
                          >
                            {userName[0][0]}
                          </abbr>
                        </p>
                      );
                    })()
                  : ""}
              </Box>
            </IconButton>
          </Tooltip>
          <Box>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1,
                  "&::before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem
                onClick={handleClose}
                sx={{
                  display:
                    deviceSize === DESKTOP_4K_SIZE_SCREEN ||
                    deviceSize === LAPTOP_SIZE_SCREEN
                      ? "none"
                      : "block",
                }}
              >
                <ListItemIcon>
                  <TopBarStyeldBox>
                    <img
                      src={Bell}
                      alt="Bell"
                      style={{
                        height: "20px",
                        width: "20px",
                        objectFit: "contain",
                      }}
                    />
                  </TopBarStyeldBox>
                </ListItemIcon>
                Notification
              </MenuItem>
              {/* <MenuItem onClick={handleClose}>
                <ListItemIcon>
                  <TopBarStyeldBox sx={{ marginLeft: "0.3rem" }}>
                    <img
                      src={QuestionMarkCircle}
                      alt="logo"
                      style={{
                        height: "20px",
                        width: "20px",
                        objectFit: "contain",
                      }}
                    />
                  </TopBarStyeldBox>
                </ListItemIcon>
                Help
              </MenuItem> */}
              <MenuItem
                onClick={handleClose}
                sx={{
                  display:
                    deviceSize === DESKTOP_4K_SIZE_SCREEN ||
                    deviceSize === LAPTOP_SIZE_SCREEN
                      ? "none"
                      : "block",
                }}
              >
                <TopBarSearchStyledBox
                  deviceSize={deviceSize as DeviceSizeProps}
                >
                  {/* <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "4px",
                      width: "100%",
                    }}
                  >
                    <InputBase
                      placeholder="Search Here"
                      sx={{
                        marginLeft: "0.5rem",
                        flex: 1,
                        ".MuiInputBase-input": {
                          color: "#00000166",
                        },
                      }}
                      value={searchQuery}
                      onChange={(event) =>
                        handleSearchChange(event.currentTarget)
                      }
                    />
                    <SearchIcon
                      sx={{ ml: "0.5rem", pr: "1rem", color: "#000000" }}
                    />
                  </Box> */}
                </TopBarSearchStyledBox>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <Typography
                  sx={{
                    padding: "15px auto",
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                >
                  <b>
                    {"userName" in localStorage &&
                    localStorage.getItem("userName") !== null
                      ? (() => {
                          const userName = localStorage.getItem("userName")!;
                          return (
                            userName.charAt(0).toUpperCase() + userName.slice(1)
                          );
                        })()
                      : ""}
                  </b>
                </Typography>
              </MenuItem>
              <MenuItem onClick={logout}>
                <ListItemIcon>
                  <TopBarStyeldBox>
                    <img
                      src={Logout}
                      alt="Bell"
                      style={{
                        height: "20px",
                        width: "20px",
                        objectFit: "contain",
                      }}
                    />
                  </TopBarStyeldBox>
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      </Box>
    </AppBar>
  );
};
